// extracted by mini-css-extract-plugin
export default {"staticInfoCard":"static-info-card_staticInfoCard__fJ8tW"};